'use client'

import dynamic from 'next/dynamic'

import { RenderOnScroll } from '@/components/RenderOnScroll'

const DynamicShowcaseSection = dynamic(() =>
	import('./ShowcaseSection').then((mod) => mod.ShowcaseSection),
)

export const LazyShowcaseSection = () => (
	<div id="showcase" className="min-h-[950px]">
		<RenderOnScroll element={<DynamicShowcaseSection />} />
	</div>
)
